module.exports = __webpack_public_path__ + "img/r-logo.63cead25.svg";